import * as React from "react";

function ExternalLink(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7397 13.5174L18.2246 7.03485V11.1111H20.003V4H12.8894V5.77777H16.967L10.4822 12.2603L11.7397 13.5174ZM18.2272 18.2228V13.7784H16.4488V18.2228H5.7784V7.5562H10.2244V5.77842H5.7784C4.79621 5.77842 4 6.57436 4 7.5562V18.2228C4 19.2047 4.79621 20.0006 5.7784 20.0006H16.4488C17.431 20.0006 18.2272 19.2047 18.2272 18.2228Z"
      />
    </svg>
  );
}

export default ExternalLink;
